import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'vc-floating-cart-proceed-button',
  templateUrl: './floating-cart-proceed-button.component.html',
  styleUrls: ['./floating-cart-proceed-button.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FloatingCartProceedButtonComponent implements OnInit {
  public pending = false;
  constructor() {}

  ngOnInit() {}

  launchLoader() {
    this.pending = true;
  }
}
